/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const VignetteIcon = ({ width = 24, height = 24, hidden = false, title = 'Vignette' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M31 4H5a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-1 26H6V6h24Z"
    />
    <path
      d="M28 15.632V8h-7.632A10.283 10.283 0 0 1 28 15.632ZM15.632 8H8v7.632A10.283 10.283 0 0 1 15.632 8ZM8 20.368V28h7.632A10.283 10.283 0 0 1 8 20.368ZM20.368 28H28v-7.632A10.283 10.283 0 0 1 20.368 28Z"
    />
  </svg>`;
};
